import React from 'react';
import PriceMatrixRow from './PriceMarixRow';

const PriceMatrixBody = (props) => {
  const { quantities, matrix } = props;

  const rows = quantities.map((qty) => {
    // matrix[quantities][vendor-group][lead_time] => price
    const pricesByQuantity = matrix[qty.toString()];
    const hideQuantityCell = Object.keys(pricesByQuantity).length > 1;
    const rowSpanQuantityCell = Object.keys(pricesByQuantity).length

    const listGroups = []
    Object.keys(pricesByQuantity).forEach((groupName) => {
      const priceRow = pricesByQuantity[groupName];
      listGroups.push(<PriceMatrixRow
        {...props}
        key={`${qty}-${groupName}`}
        quantity={qty}
        groupName={groupName}
        priceRow={priceRow}
        hideQuantityCell={hideQuantityCell && listGroups.length > 0}
        rowSpanQuantityCell={rowSpanQuantityCell} />)
    });

    return listGroups;
  });

  return (
    <tbody>
      {rows}
    </tbody>
  );
};
PriceMatrixBody.defaultProps = {
  quantities: [],
};

export default PriceMatrixBody;
